module.exports = __webpack_public_path__ + "img/topban.99da4c58.png";